import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions } from 'components/shared/StandardModal';
import { BodySmall } from 'styles/typography';

type Props = {
  flagTitle: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EnableFlagModal({ flagTitle, loading, onConfirm, onCancel }: Props) {
  return (
    <StandardModal title='Enable Feature Flag' onCancel={onCancel}>
      <Content>
        <BodySmall>
          <strong>Enable {flagTitle} for everyone?</strong> Users may still need appropriate configuration or
          permissions to access this feature.
        </BodySmall>
        <Actions>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading ? 'Enabling...' : 'Enable for Everyone'}
          </Button>
        </Actions>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
